<aims-side-menu>
  <ng-template>
    <aims-side-menu-header [displayText]="'AIMS Profile'">
      <aims-side-menu-link [route]="'./'"
                           [iconClass]="'fas fa-user'">
        My User Profile
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./macAddresses'"
                           [iconClass]="'fas fa-list-ol'">
        My MAC Addresses
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./travelDefaults'"
                           [iconClass]="'fas fa-luggage-cart'">
        My Travel Defaults
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./passwordReset'"
                           [iconClass]="'fas fa-unlock-alt'">
        AIMS Password Reset
      </aims-side-menu-link>
    </aims-side-menu-header>
  </ng-template>
</aims-side-menu>
